import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { response } from '../common/interface';

@Injectable({
  providedIn: 'root'
})
export class BarristerService {

  constructor(
    private http : HttpClient
  ) { }

  getBarristers(accessType, status){
    let params : HttpParams = new HttpParams().set('accessType', accessType).set("active", status);
    return this.http.get<response>(environment.url + "barristers", {params : params});
  }

  checkAvaialibility(id, courtDate){
    let params : HttpParams = new HttpParams().set('id', id).set("courtDate", courtDate);
    return this.http.get<response>(environment.url + "barristers/availibility", {params : params});
  }

  getBarrister(id){
    let params: HttpParams = new HttpParams().set('id', id);
    return this.http.get<response>(environment.url + "barrister", {params : params});
  }

  saveBarrister(barrister){
    return this.http.post<response>(environment.url + "barristers", barrister);
  }

  updateBarrister(id, barrister){
    return this.http.put<response>(environment.url + "barristers/"+id, barrister);
  }

  generateReport(searchData){
    return this.http.post<response>(environment.url + "barristers/search", searchData);
  }

  getHolidays(id, barristerId){
    let params: HttpParams = new HttpParams().set('id', id).set('barristerId', barristerId);
    return this.http.get<response>(environment.url + "barristers/holidays", {params : params});
  }

  saveHoliday(data){
    return this.http.post<response>(environment.url + "barristers/holiday", data);
  }

  updateHoliday(id, data){
    return this.http.put<response>(environment.url + "barristers/holiday/"+id, data);
  }

  deleteHoliday(id, password){
    let params : HttpParams = new HttpParams().set('id', id).set('password', password);
    return this.http.delete<response>(environment.url+"barristers/holiday", {params : params });
  }

}
